import { FirestoreOrganisationSalesDataLake } from "reedy-data/models";

export const isSalesDataLakeEnabled = (
  salesDataLake: FirestoreOrganisationSalesDataLake | null | undefined,
): boolean =>
  Boolean(
    salesDataLake &&
      salesDataLake !== FirestoreOrganisationSalesDataLake.DISABLED,
  );
